export function getQueryParams(locationSearch?: string) {
  const search = locationSearch ? locationSearch : window.location.search;
  const urlSearchParams = new URLSearchParams(search);
  // eslint-disable-next-line compat/compat
  return Object.fromEntries(urlSearchParams.entries());
}
